
// read https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c
import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useReactContextDevTool } from 'hooks'

export const UserContext = createContext();

// initial state
const initState = {
  user: null,
  userLoading: false,
  userFailure: false,
  userAuthenticated: false,
  gatherRedirect: '/',
  isPreviousGatherPage: true,
  subwebsFavorites: []
};

// actions
export const actions = {
  QUERY_CURRENT_USER_SUCCESS: 'QUERY_CURRENT_USER_SUCCESS',
  QUERY_CURRENT_USER_LOADING: 'QUERY_CURRENT_USER_LOADING',
  QUERY_CURRENT_USER_FAILURE: 'QUERY_CURRENT_USER_FAILURE',
  LOGOUT_USER: 'LOGOUT_USER',
  UPDATE_GATHER_REDIRECT: 'UPDATE_GATHER_REDIRECT',
  UPDATE_GATHER_PREVIOUS: 'UPDATE_GATHER_PREVIOUS',
  ADD_USER_SUBWEB: 'ADD_USER_SUBWEB',
};

// reducer
const reducer = (state, action) => {
  const { type, data } = action;

  switch (type) {
  case actions.QUERY_CURRENT_USER_SUCCESS:
    return {
      ...state,
      user: {
        ...state.user,
        ...data
      },
      userAuthenticated: true,
      userFailure: false,
      userLoading: false,
    };
  case actions.QUERY_CURRENT_USER_FAILURE:
    return {
      ...state,
      user: null,
      userAuthenticated: false,
      userFailure: true,
      userLoading: false,
    };
  case actions.QUERY_CURRENT_USER_LOADING:
    return {
      ...state,
      userAuthenticated: false,
      userFailure: false,
      userLoading: true,
    };
  case actions.UPDATE_GATHER_REDIRECT:
    return {
      ...state,
      gatherRedirect: data,
    };
  case actions.LOGOUT_USER:
    return {
      ...state,
      user: null,
      userAuthenticated: false,
      userFailure: false,
      userLoading: false,
    };
  case actions.UPDATE_GATHER_PREVIOUS:
    return {
      ...state,
      isPreviousGatherPage: data
    };
  case actions.ADD_USER_SUBWEB:
    return {
      ...state,
      user: {
        ...state.user,
        subwebs: [
          ...state.user.subwebs,
          data
        ]
      }
    };
  default:
    return state;
  }
};

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)
  useReactContextDevTool({ id: 'user', displayName: 'User', values: state })
  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  );
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUserContext = () => useContext(UserContext);

export function updateGatherRedirect(dispatch, url) {
  const blackList = ['/gather', '/login'];
  let path = url;
  if (blackList.includes(url)) path = '/';
  dispatch({
    type: actions.UPDATE_GATHER_REDIRECT,
    data: path,
  });
}

export function isUserSubwebAdmin(user, subweb) {
  if (!subweb || !user || !user.subwebs || !user.subwebs.length > 0) return false
  const subwebData = user.subwebs.find(
    subwebData => subwebData.slug === subweb || encodeURIComponent(subwebData.slug) === subweb
  )
  return (subwebData && subwebData.admin) ? subwebData.admin : false
}
